import React, { useEffect } from "react";
import { Box, Typography, Container,Grid } from "@mui/material";
import { motion} from "framer-motion";
import Footer from "./Footer";

const Retailcs2 = () => {
    useEffect(() => {
            window.scrollTo(0, 0); // Scroll to top when component loads
          },[]);

  return (
    <Box  sx={{backgroundColor:"#C4D8E2"}}>

      {/* Hero Section */}
      <Box
        sx={{
          height: "100vh",
          backgroundImage: `url('/image/retailcs2.jpg')`, // replace with your image
          backgroundSize: "cover",
          backgroundPosition: "center",
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          px: { xs: 3, md: 10 },
        }}
      >
        <Box maxWidth="1200px"  p={4} borderRadius={2}>
          <Typography variant="h1" sx={{ color: "white",  fontWeight:"bold" , fontSize: { xs: "28px", md: "70px" }}}>
         
          Innovating at the speed of the market
          </Typography>
        </Box>
      </Box>

      {/* Business Needs Section */}
      <Container sx={{ py: 10 }}>
      <Typography variant="body1" sx={{ color: "#333", fontSize: "18px" }}>
      With its freight forwarding cloud solutions in high demand — the company doubled in size in three years — Flexport needed to maximize its team resources.   </Typography>
      <Typography variant="body1" sx={{ mt: 2, color: "#333", fontSize: "18px"  }} mb={8}>
      Working with Tech Informatic Solutions, Flexport implemented automation that delivers best practice-based infrastructure with built-in security standards. Flexport also gained self-service capabilities that allow its engineering team to focus on building.   </Typography>
        
        <Typography variant="h4" fontWeight="bold" mb={3}>
          Business Needs
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Flexport is a rapidly growing organization that’s reshaping how global trade gets done. Through its advanced technology, logistics infrastructure and supply chain expertise, the company provides modern freight forwarding services. Demand for Flexport’s cloud software and data analytics services has risen so quickly that the company doubled in size in three years to keep pace. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Flexport began its Amazon Web Services (AWS) journey with a single account. However, multiple years of explosive growth meant the company needed to scale out its AWS infrastructure. With team members’ time already in high demand, Flexport turned to the Tech Informatic Solutions team for help. Flexport’s Cloud Infrastructure team led the charge, working closely with Flexport Engineering teams and Tech Informatic Solutions AWS consultants.</Typography>
       
         {/* outcome Section */}
       <Typography variant="h4" fontWeight="bold" mb={-12}>
         Outcomes
        </Typography>
       
      </Container>
      <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Speeds time to market by removing barriers to innovation",
                "Frees operations from maintenance overhead",
                "Improves productivity with automation",
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Standardizes security for reduced risk and greater repeatability",
                "Builds in compliance to CIS AWS Foundations standards",
                "Provides policy control mechanisms",
              ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>





      <Container sx={{ py: 10 }}>
      
       
      <Typography  variant="h4" fontWeight="bold" mb={3}>
      Solution
          </Typography>
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Provides policy control mechanisms
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Tech Informatic Solutions helped Flexport implement automation that delivers infrastructure built with cloud and security best practices. Self-service capabilities reduce the complexity of multiple AWS account architectures. </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333" }}mb={3}>
        Flexport needed a baseline to establish a secure foundation for workloads. It used Tech Informatic Solutions’s Build Cloud Foundations solution to create a secure, scalable and extendable cloud structure with AWS services, including AWS Control Tower. With a sound foundation, these services work together to form a security baseline that enables greater agility and flexibility.  </Typography>
         
        <Typography variant="h5" fontWeight="bold" mb={3}>
        Using AWS Control Tower
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        AWS Control Tower makes it easy to set up, govern and secure multiple accounts using built-in AWS services. New accounts can be provisioned quickly through the AWS Control Tower dashboard, which provides built-in guardrails to protect AWS accounts. The first step to deploying the new Flexport solution was enabling and enhancing AWS Control Tower’s Account Factory with a customization pipeline that deploys: </Typography>
       
        <Container maxWidth="lg">
        <Grid container spacing={3} sx={{ mt: 4 }} mb={8}>
          {[
            {
              bgImage: "/image/f3.jpeg", // Replace with actual image path
              points: [
                "Centralized log gathering that includes AWS CloudTrail, VPC Flow Logs and AWS Config to support traceability and strengthen compliance",
                "AWS Security Hub and Amazon GuardDuty to give security teams full visibility across AWS organizations",
                
              ],
            },
            {
              bgImage: "/image/f2.jpeg", // Replace with actual image path
              points: [
                "Notifications to the security team for corrective action when the system detects guardrail changes",
                "Amazon CloudWatch custom metrics and alerts to enhance security and compliance for AWS organizations",
                
                
                ],
            },
          ].map((feature, index) => (
            <Grid item xs={12} md={6} key={index}>
              <motion.div
                whileHover={{ y: -5 }} // Jump effect on hover
                transition={{ type: "spring", stiffness: 200, damping: 10 }}
              >
                 <Box
                  sx={{
                    position: "relative",
                    backgroundImage: `url(${feature.bgImage})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    borderRadius: "12px",
                    p: 4,
                    minHeight: "250px",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between", // ✅ Ensures equal spacing
                    overflow: "hidden",
                    textAlign: "left", // ✅ Left-aligned text
                  }}
                >
                  {/* Dark Overlay for Better Visibility */}
                  <Box
                    sx={{
                      position: "absolute",
                      top: 0,
                      left: 0,
                      width: "100%",
                      height: "100%",
                      backgroundColor: "rgba(0, 0, 0, 0.6)", // Reduced brightness
                      zIndex: 1,
                    }}
                  />

                  {/* Bullet Points - Always Visible */}
                  <Box
                    sx={{
                      position: "relative",
                      zIndex: 2,
                      display: "flex",
                      flexDirection: "column",
                      gap: "30px", // ✅ Creates space between two bullet points
                      minHeight: "100%", // ✅ Ensures equal height
                      mt:6,
                    }}
                  >
                    {feature.points.map((point, i) => (
                      <Box
                        key={i}
                        sx={{
                          display: "flex",
                          alignItems: "flex-start", // ✅ Aligns bullet with text properly
                          gap: "8px",
                          color: "white",
                          minHeight: "50px", // ✅ Ensures each bullet aligns properly
                        }}
                      >
                        <Typography
                          component="span"
                          sx={{
                            fontSize: "1.5rem",
                            lineHeight: "1.5rem", // ✅ Ensures bullet stays aligned
                          }}
                        >
                          ✅
                        </Typography>
                        <Typography
                          variant="body1"
                          sx={{
                            fontSize: { xs: "1rem", md: "1.2rem" },
                            lineHeight: "1.5rem", // ✅ Ensures text stays in line
                          }}
                        >
                          {point}
                        </Typography>
                      </Box>
                    ))}
                  </Box>
                </Box>
              </motion.div>
            </Grid>
          ))}
        </Grid>
      </Container>


      



        <Typography variant="h5" fontWeight="bold" mb={3}>
        Solution benefits
        </Typography>
        <Typography variant="body1" sx={{ fontSize: "18px", color: "#333", mb: 3 }}>
        Flexport has established automation that delivers self-service capabilities to its engineers. It removes the underlying complexity so they can focus on building the company’s platform for global logistics. With a network that scales to fully deliver on the cloud’s promise of greater agility, Flexport has business flexibility. It can quickly pivot to meet changing market demands and customer needs, ensuring its continued momentum.</Typography>
       
</Container>



<Footer/>
    </Box>


  );
};

export default Retailcs2;
